const state = {
  token: null,
  user: null,
};

const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setUser(state, user) {
    state.user = user;
  },
};

const actions = {
  login() {
    // Chame o serviço de autenticação
  },
  logout({ commit }) {
    commit("setToken", null);
    commit("setUser", null);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
